import { Action } from '@ngrx/store';
import { IEinConfiguration, IFormConfiguration } from '../../../commons';

export enum EinConfigurationActionTypes {
  LoadEinConfigurationState = '[EinConfiguration] Load EinConfiguration State',
  LoadEinConfigurationStateSuccess = '[EinConfiguration] Load EinConfiguration State Success',
  SaveEINOrgDetail = '[EinConfiguration] Save EIN Org Detail',
  SaveEINOrgDetailSuccess = '[EinConfiguration] Save EIN Org Detail Success',
  LoadEinConfigurationStateFail = '[EinConfiguration] Load EinConfiguration State Fail',
  EinConfigurationScreenErrorReset = '[EinConfiguration] EinConfiguration Screen Error Reset',
  EinConfigurationInitialState = '[EinConfiguration] EinConfiguration Screen Initial State'

}

export class LoadEinConfigurationState implements Action {
  readonly type = EinConfigurationActionTypes.LoadEinConfigurationState;
}

export class LoadEinConfigurationStateSuccess implements Action {
  readonly type = EinConfigurationActionTypes.LoadEinConfigurationStateSuccess;
  constructor(public payload: IEinConfiguration[] ) {}
}

export class SaveEINOrgDetail implements Action {
  readonly type = EinConfigurationActionTypes.SaveEINOrgDetail;
  constructor(public payload: any ) {}
}

export class SaveEINOrgDetailSuccess implements Action {
  readonly type = EinConfigurationActionTypes.SaveEINOrgDetailSuccess;
}

export class LoadEinConfigurationStateFail implements Action {
  readonly type = EinConfigurationActionTypes.LoadEinConfigurationStateFail;
  constructor(public payload: any) {}
}

export class EinConfigurationScreenErrorReset implements Action {
  readonly type = EinConfigurationActionTypes.EinConfigurationScreenErrorReset;
}

export class EinConfigurationInitialState implements Action {
  readonly type = EinConfigurationActionTypes.EinConfigurationInitialState;
}

export type EinConfigurationActions = 
  LoadEinConfigurationState
  | LoadEinConfigurationStateSuccess
  | SaveEINOrgDetail
  | SaveEINOrgDetailSuccess
  | LoadEinConfigurationStateFail
  | EinConfigurationScreenErrorReset
  | EinConfigurationInitialState;